import ModalAddSizes from './ModalAddSizes';

export default ModalAddSizes;
